import React from "react";

import { Stepper } from "../components/ui/stepper";
import { LandingElizaForm } from "../components/landingEliza/LandingElizaForm";
import { ELIZA_FORM_STEPS } from "../lib/constants";

const NcElizaPage = () => {
  return (
    <div>
      <img
        src="/assets/landing-page-grid-img.png"
        alt="background"
        className="fixed inset-x-0 h-[70dvh] opacity-5 select-none -z-40 w-full  object-cover mask-gradient-to-b object-top"
      />

      <Stepper initialStep={ELIZA_FORM_STEPS.ETHNICITY}>
        <LandingElizaForm />
      </Stepper>
    </div>
  );
};

export default NcElizaPage;
